import React from 'react';
import PublicGivingCampaign from '../components/PublicGivingCampaign';

const PublicGivingCampaignApp = (props) => (
  <PublicGivingCampaign {...props} />
);

export default PublicGivingCampaignApp;
